import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
import commonSlice from "./commonSlice";
import campaignSlice from "./campaign";
import shippingServiceReducer from './shippingServiceSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    common: commonSlice,
    campaign: campaignSlice,
    shippingService: shippingServiceReducer,
  },
});

export default store;
